export const bodyTypeMap: Record<number, string> = {
	1: "Sedan",
	2: "Hatch",
	3: "Pickup",
	4: "Caminhonete",
	5: "Coupe",
	6: "SUV",
	7: "Caminhão",
	8: "Veículo utilitário",
	9: "Motocicleta",
	10: "Reboque",
	11: "Semi-reboque",
};

export const transmissionTypeMap: Record<number, string> = {
	1: "Manual",
	2: "Automático",
	3: "SemiAutomatico",
	4: "CVT",
};

export const engineTypeMap: Record<number, string> = {
	1: "Combustão interna",
	2: "Elétrico",
	3: "Hibrido",
};

export const mapBodyTypeToLabel = (bodyType: number): string =>
	bodyTypeMap[bodyType] || "Desconhecido";

export const mapTransmissionTypeToLabel = (transmissionType: number): string =>
	transmissionTypeMap[transmissionType] || "Desconhecido";

export const mapEngineTypeToLabel = (engineType: number): string =>
	engineTypeMap[engineType] || "Desconhecido";

export const getLabelByValue = (
	map: Record<number, string>,
	value: string
): number | null => {
	const entry = Object.entries(map).find(([_, label]) => label === value);
	return entry ? Number(entry[0]) : null;
};
